import ContractorRegistrationPage from "../../shared/contractor-registration/ContractorRegistrationPage";
import { CONTRACTOR_REGISTRATION_CONFIG } from "../../shared/contractor-registration/contractorRegistrationConfig";

export default function SolarentOperatorContractorRegistrationPage() {
  return (
    <ContractorRegistrationPage
      {...CONTRACTOR_REGISTRATION_CONFIG.solarentOperator}
    />
  );
}
